import { createSlice } from '@reduxjs/toolkit';
import { type FacilityState } from '../../types/store/states/FacilityState';
import {
  changeAudioCallingEnabled,
  changeCommunicationsEnabled,
  changeMusicEnabled,
  changeReferenceMaterialEnabled,
  changeTextingLocalStatus,
  changeVideoCallingEnabled,
} from '../thunks/facility';

const initialState: FacilityState = {
  communicationsEnabledChanging: false,
  textingEnabledChanging: false,
  audioCallingEnabledChanging: false,
  videoCallingEnabledChanging: false,
  musicEnabledChanging: false,
  referenceMaterialEnabledChanging: false,
} as FacilityState;

const facility = createSlice({
  reducerPath: undefined,
  selectors: undefined,
  reducers: {},
  name: 'facility',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(changeCommunicationsEnabled.pending, (state) => {
        state.communicationsEnabledChanging = true;
      })
      .addCase(changeCommunicationsEnabled.fulfilled, (state) => {
        state.communicationsEnabledChangeError = null;
        state.communicationsEnabledChanging = false;
      })
      .addCase(changeCommunicationsEnabled.rejected, (state, action) => {
        state.communicationsEnabledChanging = false;
        state.communicationsEnabledChangeError = action.error;
      })
      .addCase(changeTextingLocalStatus.pending, (state) => {
        state.textingEnabledChanging = true;
      })
      .addCase(changeTextingLocalStatus.fulfilled, (state) => {
        state.textingEnabledChangeError = null;
        state.textingEnabledChanging = false;
      })
      .addCase(changeTextingLocalStatus.rejected, (state, action) => {
        state.textingEnabledChanging = false;
        state.textingEnabledChangeError = action.error;
      })
      .addCase(changeAudioCallingEnabled.pending, (state) => {
        state.audioCallingEnabledChanging = true;
      })
      .addCase(changeAudioCallingEnabled.fulfilled, (state) => {
        state.audioCallingEnabledChangeError = null;
        state.audioCallingEnabledChanging = false;
      })
      .addCase(changeAudioCallingEnabled.rejected, (state, action) => {
        state.audioCallingEnabledChanging = false;
        state.audioCallingEnabledChangeError = action.error;
      })
      .addCase(changeVideoCallingEnabled.pending, (state) => {
        state.videoCallingEnabledChanging = true;
      })
      .addCase(changeVideoCallingEnabled.fulfilled, (state) => {
        state.videoCallingEnabledChangeError = null;
        state.videoCallingEnabledChanging = false;
      })
      .addCase(changeVideoCallingEnabled.rejected, (state, action) => {
        state.videoCallingEnabledChanging = false;
        state.videoCallingEnabledChangeError = action.error;
      })
      .addCase(changeMusicEnabled.pending, (state) => {
        state.musicEnabledChanging = true;
      })
      .addCase(changeMusicEnabled.fulfilled, (state) => {
        state.musicEnabledChangeError = null;
        state.musicEnabledChanging = false;
      })
      .addCase(changeMusicEnabled.rejected, (state, action) => {
        state.musicEnabledChanging = false;
        state.musicEnabledChangeError = action.error;
      })
      .addCase(changeReferenceMaterialEnabled.pending, (state) => {
        state.referenceMaterialEnabledChanging = true;
      })
      .addCase(changeReferenceMaterialEnabled.fulfilled, (state) => {
        state.referenceMaterialEnabledChangeError = null;
        state.referenceMaterialEnabledChanging = false;
      })
      .addCase(changeReferenceMaterialEnabled.rejected, (state, action) => {
        state.referenceMaterialEnabledChanging = false;
        state.referenceMaterialEnabledChangeError = action.error;
      });
  },
});

export default facility.reducer;
